import { useEffect, useState } from 'react'
import { getUrl } from 'aws-amplify/storage'
import './s3-image.scss'

const S3Image = ({ imageKey, fallbackIcon }) => {
  const [src, setSrc] = useState(null)

  useEffect(() => {
    let isMounted = true
    const getS3Image = async (key) => {
      try {
        const { url } = await getUrl({
          key: key.replace(/^\/+/, ''),
          options: {
            accessLevel: 'public',
          },
        })
        if (isMounted) {
          setSrc(url.toString())
        }
      } catch (err) {
        console.error('Failed to load S3 image', err)
      }
    }
    if (imageKey && !src) {
      getS3Image(imageKey)
    }
    return () => {
      isMounted = false
    }
  }, [imageKey, src])

  if (!src) {
    return (
      <div className="s3-image-wrapper">
        <div className="svg-placeholder">{fallbackIcon}</div>
      </div>
    )
  }

  return (
    <div className="s3-image-wrapper">
      <img src={src} alt={imageKey} className="image" />
    </div>
  )
}

export default S3Image

